
import TheParentFleetSelectorList from "@/layouts/navigation/TheParentFleetSelector.vue";
import ThePartnerSelectorList from "@/layouts/navigation/ThePartnerSelectorList.vue";
import { AppContextEnum } from "@/lib/enum/appContext.enum";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { IUser } from "@/models/user.entity";
import { MrfiktivFleetViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { ConfigModule } from "@/store/modules/config";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: { ThePartnerSelectorList, TheParentFleetSelectorList }
})
export default class ProfileMenu extends Vue {
  @Prop({ default: false })
  isEndUser!: boolean;

  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;

  logout() {
    this.$router.push({ name: "Logout" });
  }

  get partner() {
    return PartnerModule.partner;
  }

  get partners() {
    return PartnerModule.partners;
  }

  get companyName() {
    return PartnerModule.partner?.companyName || "";
  }

  get isReport() {
    return AppContextEnum.REPORT === ConfigModule.appContext;
  }

  get fleetPartnerPermission() {
    if (this.partner.id) {
      return UserModule.fleetPermission.filter(p => this.partner.id === p.partnerId);
    }

    return UserModule.fleetPermission;
  }

  /**
   * Distinct list of fleetId found in fleet permission for current partner.
   */
  get permissionFleetIds() {
    return [...new Set(this.fleetPartnerPermission.map(p => p.fleetId))];
  }

  get permissionFleets(): MrfiktivFleetViewModelGen[] {
    return FleetManagerModule.permissionFleets.filter(f => f.partnerId === this.partner.id);
  }

  get parentFleets(): MrfiktivFleetViewModelGen[] {
    return FleetManagerModule.fleets;
  }

  get firstParentFleet() {
    return this.parentFleets?.[0];
  }

  /**
   * Returns primary color if !enduser, else returns custom partner color
   */
  get color() {
    if (this.isEndUser) {
      return getDefaultPartnerColor();
    } else {
      return "primary";
    }
  }

  get isAuthenticated() {
    return UserModule.isAuthenticated;
  }

  get user(): IUser {
    return UserModule.user;
  }

  get logOut() {
    const item = {
      icon: "mdi-logout",
      text: "Logout",
      link: "/login/logout"
    };
    return item;
  }

  isLogoutLoading = false;

  async performLogout() {
    this.isLogoutLoading = true;
    try {
      await UserModule.logout();
    } catch {
      this.isLogoutLoading = false;
    }
  }

  get userItem() {
    const item = {
      icon: "mdi-account-outline",
      text: "Profil",
      link: "/profile"
    };
    return item;
  }
}
